import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { CheckCircle, XCircle, Calculator, Play } from 'lucide-react';

const AnalogyCard = ({ analogy }) => {
  return (
    <Card className="bg-gray-900/50 border-gray-800 card-hover">
      <CardHeader>
        <CardTitle className="text-xl text-white">{analogy.title}</CardTitle>
        <CardDescription className="text-emerald-500 font-medium">
          {analogy.category}
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Video Preview - Available or Coming Soon */}
        <div className="mb-4">
          {analogy.videoUrl ? (
            <a 
              href={analogy.videoUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative block rounded-lg overflow-hidden border border-emerald-500/20 hover:border-emerald-500/40 transition"
            >
              <div className="relative" style={{ paddingBottom: '56.25%', height: 0 }}>
                <img 
                  src={`https://img.youtube.com/vi/${analogy.videoUrl.split('youtu.be/')[1] || analogy.videoUrl.split('v=')[1]}/mqdefault.jpg`}
                  alt={`${analogy.title} video preview`}
                  className="absolute top-0 left-0 w-full h-full object-cover"
                  width="640"
                  height="360"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition flex items-center justify-center">
                  <div className="bg-emerald-600 rounded-full p-3 group-hover:scale-110 transition">
                    <Play className="w-6 h-6 text-white fill-white" />
                  </div>
                </div>
              </div>
              <div className="bg-gray-800/50 px-3 py-2">
                <span className="text-xs text-emerald-400">▶ Watch Video Explanation</span>
              </div>
            </a>
          ) : (
            <div className="relative block rounded-lg overflow-hidden border border-gray-700 bg-gray-800/30">
              <div className="relative" style={{ paddingBottom: '56.25%', height: 0 }}>
                <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-gray-800/50 to-gray-900/50 flex items-center justify-center">
                  <div className="text-center">
                    <div className="bg-gray-700/50 rounded-full p-3 mb-3 inline-block">
                      <Play className="w-6 h-6 text-gray-500" />
                    </div>
                    <p className="text-gray-400 text-sm font-medium">Video Coming Soon</p>
                    <p className="text-gray-500 text-xs mt-1">Video explanation in progress</p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-800/50 px-3 py-2">
                <span className="text-xs text-gray-500">📹 Video Explanation Coming Soon</span>
              </div>
            </div>
          )}
        </div>
        {/* Story */}
        <div>
          <h4 className="text-sm font-semibold text-gray-300 mb-2">Story</h4>
          <p className="text-gray-400 text-sm leading-relaxed">{analogy.story}</p>
        </div>

        {/* Pros */}
        <div>
          <h4 className="text-sm font-semibold text-gray-300 mb-2 flex items-center">
            <CheckCircle className="w-4 h-4 text-emerald-500 mr-2" />
            Pros
          </h4>
          <ul className="space-y-1">
            {analogy.pros.map((pro, idx) => (
              <li key={idx} className="text-sm text-gray-400 flex items-start">
                <span className="text-emerald-500 mr-2">•</span>
                <span>{pro}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Cons */}
        <div>
          <h4 className="text-sm font-semibold text-gray-300 mb-2 flex items-center">
            <XCircle className="w-4 h-4 text-red-500 mr-2" />
            Cons
          </h4>
          <ul className="space-y-1">
            {analogy.cons.map((con, idx) => (
              <li key={idx} className="text-sm text-gray-400 flex items-start">
                <span className="text-red-500 mr-2">•</span>
                <span>{con}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Formula */}
        <div className="bg-emerald-500/10 border border-emerald-500/20 rounded-lg p-3">
          <h4 className="text-sm font-semibold text-emerald-400 mb-1 flex items-center">
            <Calculator className="w-4 h-4 mr-2" />
            Key Formula
          </h4>
          <p className="text-sm text-gray-300 font-mono">{analogy.formula}</p>
        </div>
      </CardContent>
    </Card>
  );
};

export default AnalogyCard;